import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  ICONFERENCE,
  ICONFERENCE_ALL,
  ICONFERENCE_ALL_FILTER,
  ICONFERENCE_ARTICLE,
  ICONFERENCE_ARTICLE_ALL,
  ICONFERENCE_ARTICLE_LIST,
  ICONFERENCE_ARTICLE_PROOF,
  ICONFERENCE_ARTICLE_STEP,
  ICONFERENCE_CATEGORY_ALL,
  ICONFERENCE_CREATE,
  ICONFERENCE_MAGAZINE_ARTICLE,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const iconference = createAsyncThunk(
  ICONFERENCE,
  async (params: PayloadCreatorParams<`${typeof API.ICONFERENCE}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.iconference(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const iconferenceCreate = createAsyncThunk(
  ICONFERENCE_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.ICONFERENCE}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.iconferenceCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const iconferenceAll = createAsyncThunk(
  ICONFERENCE_ALL,
  async (params: PayloadCreatorParams<`${typeof API.ICONFERENCE_ALL}`, 'get'> | undefined, { rejectWithValue }) => {
    try {
      const response = await api.iconferenceAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const iconferenceArticle = createAsyncThunk(
  ICONFERENCE_ARTICLE,
  async (params: PayloadCreatorParams<`${typeof API.ICONFERENCE_ARTICLE}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.iconferenceArticle(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const iconferenceArticleList = createAsyncThunk(
  ICONFERENCE_ARTICLE_LIST,
  async (
    params: PayloadCreatorParams<`${typeof API.ICONFERENCE_ARTICLE_LIST}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.iconferenceArticleList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const iconferenceArticleStep = createAsyncThunk(
  ICONFERENCE_ARTICLE_STEP,
  async (params: PayloadCreatorParams<`${typeof API.ICONFERENCE_ARTICLE_STEP}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.iconferenceArticleStep(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const iconferenceAllFilter = createAsyncThunk(
  ICONFERENCE_ALL_FILTER,
  async (
    params: PayloadCreatorParams<`${typeof API.ICONFERENCE_ALL_FILTER}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.iconferenceAllFilter(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const iconferenceArticleProof = createAsyncThunk(
  ICONFERENCE_ARTICLE_PROOF,
  async (params: PayloadCreatorParams<`${typeof API.ICONFERENCE_ARTICLE_PROOF}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.iconferenceArticleProof(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const iconferenceArticleAll = createAsyncThunk(
  ICONFERENCE_ARTICLE_ALL,
  async (
    params: PayloadCreatorParams<`${typeof API.ICONFERENCE_ARTICLE_ALL}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.iconferenceArticleAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const iconferenceMagazineArticle = createAsyncThunk(
  ICONFERENCE_MAGAZINE_ARTICLE,
  async (
    params: PayloadCreatorParams<`${typeof API.ICONFERENCE_MAGAZINE_ARTICLE}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.iconferenceMagazineArticle(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const iconferenceCategoryAll = createAsyncThunk(
  ICONFERENCE_CATEGORY_ALL,
  async (params: PayloadCreatorParams<`${typeof API.ICONFERENCE_CATEGORY_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.iconferenceCategoryAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const iconferenceClear = createAction(`${ICONFERENCE}/clear`)
export const iconferenceArticleClear = createAction(`${ICONFERENCE_ARTICLE}/clear`)

export const iconferenceAllClear = createAction(`${ICONFERENCE_ALL}/clear`)

export const iconferenceAllFilterClear = createAction(`${ICONFERENCE_ALL_FILTER}/clear`)

export const iconferenceArticleListClear = createAction(`${ICONFERENCE_ARTICLE_LIST}/clear`)

export const iconferenceArticleAllClear = createAction(`${ICONFERENCE_ARTICLE_ALL}/clear`)

export const iconferenceMagazineArticleClear = createAction(`${ICONFERENCE_MAGAZINE_ARTICLE}/clear`)

export const iconferenceCategoryAllClear = createAction(`${ICONFERENCE_CATEGORY_ALL}/clear`)
